/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AiMatchScoreMatchScoreFragmentDoc } from './MatchScore.generated';
export type DiagnosisType =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H';

export type HouseholdStructureType =
  /** 子なし夫婦世帯 */
  | 'COUPLE_WITHOUT_CHILDREN'
  /** 子あり夫婦世帯 */
  | 'COUPLE_WITH_CHILDREN'
  /** 単身世帯 */
  | 'ONE_PERSON'
  /** 定年後世帯 */
  | 'RETIRED'
  /** ひとり親世帯 */
  | 'SINGLE_WITH_CHILDREN'
  | 'UNSPECIFIED';

export type RankInCluster =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'UNSPECIFIED';

export type UserDiagnosisResultV2DiagnosisSummaryFragment = { type: Types.DiagnosisType, assetsRank: Types.RankInCluster, householdAnnualIncomeRank: Types.RankInCluster, monthlySavingRank: Types.RankInCluster, cluster: { householdStructure: Types.HouseholdStructureType, residentialArea: { country: string, prefecture: string | null, city: string | null, town: string | null }, statistics: { meanAge: number, meanNumberOfChildren: number, investmentRatio: number, meanHouseholdAnnualIncome: number, meanMonthlySaving: number, meanAssets: number } } };

export type UserDiagnosisResultV2KarteFragment = { user: { nickname: string }, diagnosis: { uuid: string, annualIncome: number, savingMonth: number, saving: number, investment: number, aiMatchScore: { lifePlanningMatchingScore: number, onetimeSaleMatchingScore: number, householdImprovementMatchingScore: number, sellingHomeMatchingScore: number, realEstateInvestmentMatchingScore: number, jobChangeMatchingScore: number } | null, partner: { annualIncome: number } | null, diagnosisSummary: { type: Types.DiagnosisType, assetsRank: Types.RankInCluster, householdAnnualIncomeRank: Types.RankInCluster, monthlySavingRank: Types.RankInCluster, cluster: { householdStructure: Types.HouseholdStructureType, residentialArea: { country: string, prefecture: string | null, city: string | null, town: string | null }, statistics: { meanAge: number, meanNumberOfChildren: number, investmentRatio: number, meanHouseholdAnnualIncome: number, meanMonthlySaving: number, meanAssets: number } } } | null } };

export const UserDiagnosisResultV2DiagnosisSummaryFragmentDoc = gql`
    fragment UserDiagnosisResultV2DiagnosisSummary on DiagnosisSummary {
  type
  assetsRank
  householdAnnualIncomeRank
  monthlySavingRank
  cluster {
    residentialArea {
      country
      prefecture
      city
      town
    }
    householdStructure
    statistics {
      meanAge
      meanNumberOfChildren
      investmentRatio
      meanHouseholdAnnualIncome
      meanMonthlySaving
      meanAssets
    }
  }
}
    `;
export const UserDiagnosisResultV2KarteFragmentDoc = gql`
    fragment UserDiagnosisResultV2Karte on Karte {
  user {
    nickname
  }
  diagnosis {
    aiMatchScore {
      ...AiMatchScoreMatchScore
    }
    uuid
    annualIncome
    savingMonth
    saving
    investment
    partner {
      annualIncome
    }
    diagnosisSummary {
      ...UserDiagnosisResultV2DiagnosisSummary
    }
  }
}
    ${AiMatchScoreMatchScoreFragmentDoc}
${UserDiagnosisResultV2DiagnosisSummaryFragmentDoc}`;